import SkeletonComponent from "core/components/Skeleton/skeleton";

const CommentItemLoading = () => {
  return (
    <div className="flex gap-3 w-full group px-4">
      <div className="h-full">
        <SkeletonComponent
          className="rounded-full float-left w-8 min-w-8 h-8 object-cover"
        />
      </div>
      <div className="w-full space-y-1.5 pb-2.5 border-b group-last:border-b-0">
        <div
          className="space-y-1.5"
        >
          <SkeletonComponent
            className="text-[13px] w-1/2"
          />
          <SkeletonComponent className="text-[13px] text-[#333333]"/>
          <SkeletonComponent className="text-[13px] text-[#333333]"/>
          
          <SkeletonComponent className="text-[11px] w-1/4 text-[#333333]" />
        </div>
      </div>
    </div>
  );
}

export default CommentItemLoading;
